module.exports = __webpack_public_path__ + "static/media/cocoyoc_invoice_template.bd78903d.xlsx";